import { render } from "./inner-play-space.vue?vue&type=template&id=73894125"
import script from "./inner-play-space.vue?vue&type=script&lang=js"
export * from "./inner-play-space.vue?vue&type=script&lang=js"

import "./inner-play-space.vue?vue&type=style&index=0&id=73894125&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__